import script from "./PodcastAdminAlertRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminAlertRoom.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminAlertRoom.vue?vue&type=style&index=0&id=1e32f998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e32f998"]])

export default __exports__